export function getThumbnailUrl(thumbnail, width = 387, height = 200) {
    if (!thumbnail) return '';
    const separator = thumbnail.includes('?') ? '&' : '?';
    return `${thumbnail}${separator}width=${width}&height=${height}`;
}
